import { Col, Container, Form, Row } from 'react-bootstrap'
import KLayerNavigation from '../components/KLayerNavigation'
import { apiRequest, isUserLoggedIn, showKAlert, updateNestedField } from '../helpers'
import { t } from '../locale'
import {
  BuildingFillGear,
  CreditCardFill,
  FlagFill,
  Globe2,
  InfoCircleFill,
  PersonFill,
  PersonVcardFill,
} from 'react-bootstrap-icons'
import React, { useEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

export default function StammdatenRequiredCompany() {
  const [untherNamenOpen, setUntherNamenOpen] = useState(false)
  const [adressenOpen, setAdressenOpen] = useState(false)
  const [kommunikationOpen, setKommunikationOpen] = useState(false)
  const [bankenOpen, setBankenOpen] = useState(false)
  const [beziehungenOpen, setBeziehungenOpen] = useState(false)

  const [form, setForm] = useState({
    client_since: false,
    client_to: false,
    anrede: false,
    unternehmensname: false,
    unternehmensform: false,
    client_note: false,
    corporate_purpose: false,
    location_of_headquarters: false,
    country_of_headquarters: false,
    founding_date: false,
    nationality: false,
    branche: {
      description: false,
    },
    national_law: {
      eu_vat_id_country_code: false,
      federal_state: false,
    },
    registry_court: {
      register_entry: false,
      commercial_register: false,
      register_number: false,
      commercial_register_company_name: false,
    },
    address: {
      valid_since: false,
      valid_to: false,
      address_suffix: false,
      type: false,
      zip_code: false,
      city: false,
      country: false,
      shipping_supplement: false,
      note: false,
    },
    communication: {
      phone: false,
      email: false,
      url: false,
    },
    bank: {
      valid_since: false,
      valid_to: false,
      country: false,
      bank_name: false,
      iban: false,
      account_number: false,
      account_holder: false,
      note: false,
    },
    beziehung: {
      hatIst: false,
      name: false,
      addressee_type: false,
      anrede: false,
      naturliche_person_info: {
        anrede: false,
        academic_degree: false,
        first_name: false,
        name: false,
        birth_date: false,
        federal_state: false,
        eTIN: false,
        id_number: false,
      },
      legal_person_info: {
        anrede: false,
        name: false,
        legal_form: false,
      },
      tax_authority: {
        country_code: false,
        tax_authority_name: false,
        tax_number: false,
        betriebsfinanzamt: false,
        umsatzsteuerfinanzamt: false,
        lohnsteuerfinanzamt: false,
      },
      address: {
        type: false,
        zip_code: false,
        city: false,
        country: false,
        phone: false,
        email: false,
      },
    },
  })

  useEffect(() => {
    getRequired()
  }, [])

  const debouncedSave = useDebouncedCallback((field: string, value: any) => {
    save(field, value)
  }, 100)

  const changeLocal = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id } = e.target
    const value = (e.target as HTMLInputElement).checked

    setForm(prev => updateNestedField(prev, id, value))
    debouncedSave(id, value)
  }

  const save = async (id: string, value: any) => {
    apiRequest(`${process.env.REACT_APP_API_URL}/stammdaten/required`, 'POST', {
      type: 'company',
      fields: [
        {
          name: id,
          required: value,
        },
      ],
    }).then(r => {
      if (!r.ok) showKAlert('danger', 'error')
    })
  }

  const getRequired = async () => {
    const res = await apiRequest(
      `${process.env.REACT_APP_API_URL}/stammdaten/requiredBy?type=company`,
      'GET'
    )

    if (res.result) {
      res.result.fields.forEach((element: any) => {
        const fieldPath = element.name
        const value = element.required

        setForm(prev => {
          const newForm = { ...prev }
          const keys = fieldPath.split('.')
          let current: any = newForm

          for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
              current[keys[i]] = {}
            }
            current = current[keys[i]]
          }

          current[keys[keys.length - 1]] = value

          return newForm
        })
      })
    }
  }

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main className='col-md-9 col-lg-10 pb-5'>
            <h5>{t('companyRequired')}</h5>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('mandantSeit')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id='client_since'
                  checked={form.client_since}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('mandantBis')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'client_to'}
                  checked={form.client_to}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <h6 className='bg-gray-200 p-2 rounded mb-3 mt-3'>
              <BuildingFillGear />
              {t('Angaben')}
            </h6>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('anrede')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'anrede'}
                  checked={form.anrede}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('Unternehmensname')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check type='checkbox' id={'Unternehmensname'} checked={true} disabled />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('Unternehmensform')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'unternehmensform'}
                  checked={form.unternehmensform}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('Notiz')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'client_note'}
                  checked={form.client_note}
                  onChange={changeLocal}
                />
              </Col>
            </Row>

            <Row className='mt-4'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setUntherNamenOpen(!untherNamenOpen)}
              >
                <PersonFill />
                &nbsp;{t('Unternehmensdaten')}
                {<b className='ms-auto'>{untherNamenOpen ? '▼' : '►'}</b>}
              </h5>
            </Row>

            {untherNamenOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('unternehmensgegenstand')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='corporate_purpose'
                      checked={form.corporate_purpose}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('ortFirmensitezes')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='location_of_headquarters'
                      checked={form.location_of_headquarters}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('landFirmensitzes')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='country_of_headquarters'
                      checked={form.country_of_headquarters}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gründungsdatum')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='founding_date'
                      checked={form.founding_date}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col className='col-sm-2'>
                    <FlagFill />{' '}
                    <label className='form-control-label'>{t('nationalesRecht')}</label>
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('nationalesRecht')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='nationality'
                      checked={form.nationality}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('ustNr')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='national_law.eu_vat_id_country_code'
                      checked={form.national_law.eu_vat_id_country_code}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <div className='mb-3 mt-4 align-items-center'>
                  <InfoCircleFill className='me-2' /> {t('registergerichtsinformationen')}
                </div>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('registereintrag')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='registry_court.register_entry'
                      checked={form.registry_court.register_entry}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('registergericht')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='registry_court.commercial_register'
                      checked={form.registry_court.commercial_register}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('registerNr')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='registry_court.register_number'
                      checked={form.registry_court.register_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('firmennameLautRegistergericht')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='registry_court.commercial_register_company_name'
                      checked={form.registry_court.commercial_register_company_name}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setAdressenOpen(!adressenOpen)}
              >
                <PersonVcardFill />
                &nbsp;{t('Adressen')}
                {<b className='ms-auto'>{adressenOpen ? '▼' : '►'}</b>}
              </h5>
            </Row>

            {adressenOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigVon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.valid_since'}
                      checked={form.address.valid_since}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigBis')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.valid_to'}
                      checked={form.address.valid_to}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adresszusatz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.address_suffix'}
                      checked={form.address.address_suffix}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressart')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.type'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('street')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.street'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('postfachadresse')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.post_office_box'}
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.country'}
                      checked={form.address.country}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('PLZ')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.zip_code'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('place')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.city'} checked={true} disabled />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('versandzusatz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.shipping_supplement'}
                      checked={form.address.shipping_supplement}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Notiz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.note'}
                      checked={form.address.note}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setKommunikationOpen(!kommunikationOpen)}
              >
                <Globe2 />
                &nbsp;{t('Kommunikation')}
                <b className='ms-auto'>{kommunikationOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {kommunikationOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Telefon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.phone'}
                      checked={form.communication.phone}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Email')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.email'}
                      checked={form.communication.email}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('URL')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.url'}
                      checked={form.communication.url}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setBankenOpen(!bankenOpen)}
              >
                <CreditCardFill />
                &nbsp;{t('Banken')}
                <b className='ms-auto'>{bankenOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {bankenOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigVon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.valid_since'}
                      checked={form.bank.valid_since}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigBis')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.valid_to'}
                      checked={form.bank.valid_to}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.country'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('bank')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.bank_name'} checked={true} disabled />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('iban')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.iban'} checked={true} disabled />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('kontonummer')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.account_number'}
                      checked={form.bank.account_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('kontoinhaber')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.account_holder'}
                      checked={form.bank.account_holder}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Notiz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.note'}
                      checked={form.bank.note}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setBeziehungenOpen(!beziehungenOpen)}
              >
                <CreditCardFill />
                &nbsp;{t('Beziehungen')}
                <b className='ms-auto'>{beziehungenOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {beziehungenOpen && (
              <>
                <Row className='mt-2'>
                  <Col xs={2}>
                    <label>
                      {t('hat')}/{t('ist')}
                    </label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id='beziehung.hatIst' checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('beziehung')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id='beziehung.name' checked={true} disabled />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressattype')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.addressee_type'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('anrede')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.anrede'
                      checked={form.beziehung.anrede}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Unternehmensname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.legal_person_info.name'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Unternehmensform')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.legal_person_info.legal_form'
                      checked={form.beziehung.legal_person_info.legal_form}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('titelGrad')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.academic_degree'
                      checked={form.beziehung.naturliche_person_info.academic_degree}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('vorname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.first_name'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('nachname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.name'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('dateOfBirth')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.birth_date'
                      checked={form.beziehung.naturliche_person_info.birth_date}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('bundesland')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.federal_state'
                      checked={form.beziehung.naturliche_person_info.federal_state}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('idNumber')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.id_number'
                      checked={form.beziehung.naturliche_person_info.id_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <div className='bg-info-subtle p-2 rounded mb-3 mt-4 d-flex align-items-center'>
                  <InfoCircleFill className='me-2' />{' '}
                  <strong className='small'>{t('taxOffice')}</strong>
                </div>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.tax_authority.country_code'
                      checked={form.beziehung.tax_authority.country_code}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('finanzamt')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.tax_authority.tax_authority_name'
                      checked={form.beziehung.tax_authority.tax_authority_name}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('steuernummer')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.tax_authority.tax_number'
                      checked={form.beziehung.tax_authority.tax_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <div className='bg-info-subtle p-2 rounded mb-3 mt-4 d-flex align-items-center'>
                  <InfoCircleFill className='me-2' />{' '}
                  <strong className='small'>{t('communicationAndAddress')}</strong>
                </div>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressart')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.type'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('plz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.zip_code'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('place')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.city'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.country'
                      checked={form.beziehung.address.country}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('phone')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.phone'
                      checked={form.beziehung.address.phone}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('email')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.email'
                      checked={form.beziehung.address.email}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}
          </main>
        </Row>
      </Container>
    </>
  )
}
